"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainInfo = void 0;
exports.chainInfo = {
    optimism: {
        nativeToken: "ETH-op",
        name: "ethereum",
        chainId: 10,
    },
    arbitrum: {
        nativeToken: "ETH-arb",
        name: "ethereum",
        chainId: 42161,
    },
    base: {
        nativeToken: "ETH-base",
        name: "base",
        chainId: 8453,
    },
    ethereum: {
        nativeToken: "ETH",
        name: "ethereum",
        chainId: 1,
    },
    ethereum_testnet: {
        nativeToken: "ETH_t",
        name: "goerli",
        chainId: 3,
    },
    bsc: {
        nativeToken: "BNB",
        name: "binance_smart_chain",
        chainId: 56,
    },
    bsc_testnet: {
        nativeToken: "BNB_t",
        name: "binance_smart_chain_testnet",
        chainId: 97,
    },
    polygon: {
        nativeToken: "MATIC",
        name: "polygon",
        chainId: 137,
    },
    polygon_testnet: {
        nativeToken: "MATIC_t",
        name: "amoy",
        chainId: 137,
    },
    bsquared: {
        nativeToken: "BTC_B2",
        name: "bsquared",
        chainId: 223,
    },
    bsquared_testnet: {
        nativeToken: "BTC_B2_t",
        name: "bsquared",
        chainId: 223,
    },
    bob: {
        nativeToken: "BTC_BOB",
        name: "bob",
        chainId: 60808,
    },
};
//# sourceMappingURL=chain-info.js.map